import React from 'react'
import { Menu, Tabs, Tab, useTheme, Fade, IconButton } from '@mui/material'
import { Brodcast } from 'iconsax-react'

import Tooltip from '@SonarCX/components/atoms/Tooltip'
import ChangeItem from './ChangeItem'

import useStyles from './styles'

const FIXES = 0
const IMPROVEMENTS = 1

type ChangelogProps = {}

const Changelog: React.FC<ChangelogProps> = () => {
  const theme = useTheme()

  const rootRef = React.useRef(null)
  const [anchor, setAnchor] = React.useState(null)
  const isOpen = React.useMemo(() => Boolean(anchor), [anchor])
  const [tab, setTab] = React.useState(FIXES)

  const classes = useStyles()

  return (
    <>
      <Tooltip title='Changelog' arrow>
        <IconButton
          ref={rootRef}
          className={classes.iconRoot}
          onClick={e => setAnchor(e.currentTarget)}
        >
          <Brodcast size={theme.size.lg} color='black' />
        </IconButton>
      </Tooltip>

      <Menu
        elevation={3}
        anchorEl={rootRef.current}
        open={isOpen}
        onClose={e => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        TransitionComponent={Fade}
        keepMounted
      >
        <div className={classes.menuRoot}>
          <Tabs
            value={tab}
            onChange={(_, val) => setTab(val)}
            className={classes.tabs}
            centered
          >
            <Tab label='Fixes' classes={{ root: classes.tab }} />

            <Tab label='Improvements' classes={{ root: classes.tab }} />
          </Tabs>

          {tab === FIXES && (
            <ChangeItem
              type='fixes'
              id='59cc93cf-4578-47d3-b6f8-1a0a997465e6'
              isOpen={isOpen}
            />
          )}

          {tab === IMPROVEMENTS && (
            <ChangeItem
              type='improvements'
              id='5bcd5c17-c1bd-41b8-ad45-0b9d278a04df'
              isOpen={isOpen}
            />
          )}
        </div>
      </Menu>
    </>
  )
}

export default Changelog
